import type {
  OutboundWebhookPayload,
  WebhookEventName,
} from '@/modules/communications/types/webhook.types';

export function buildWebhookPayload(
  event: WebhookEventName,
  ctx: {
    companyId: string;
    actorUid: string;
    occurredAt: string;
  },
  data: Record<string, unknown>,
): OutboundWebhookPayload {
  return {
    id: crypto.randomUUID(),
    event,
    occurredAt: ctx.occurredAt,
    companyId: ctx.companyId,
    actorUid: ctx.actorUid,
    data,
  };
}
